var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"mr-1",staticStyle:{"font-size":"20px"},attrs:{"small":"","color":_vm.color},on:{"click":function($event){return _vm.action(_vm.item)}}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }